import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const VideoModal = ({ isOpen, onClose, videoUrl }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className="relative w-full max-w-5xl mx-4 bg-gray-900 rounded-2xl shadow-2xl overflow-hidden">
        {/* Close Button */}
        <Button
          onClick={onClose}
          variant="ghost"
          size="icon"
          className="absolute top-4 right-4 z-10 text-white hover:bg-white/20 rounded-full"
        >
          <X className="h-6 w-6" />
        </Button>

        {/* Video Container */}
        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          {videoUrl ? (
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src={videoUrl}
              title="MyMedMember Demo Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-gradient-to-br from-teal-600 to-cyan-600">
              <div className="text-center text-white p-8">
                <h3 className="text-2xl font-bold mb-4">MyMedMember Platform Demo</h3>
                <p className="text-lg mb-6">
                  See how MyMedMember transforms healthcare practice management with:
                </p>
                <ul className="text-left max-w-md mx-auto space-y-3 mb-8">
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">✓</span>
                    <span>Complete Patient CRM & Management</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">✓</span>
                    <span>Flexible Membership Plans & Billing</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">✓</span>
                    <span>Smart Appointment Scheduling</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">✓</span>
                    <span>Real-Time Analytics & Reports</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">✓</span>
                    <span>HIPAA-Compliant Messaging</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-2xl">✓</span>
                    <span>Automated Workflows & Reminders</span>
                  </li>
                </ul>
                <p className="text-sm opacity-90">
                  Video coming soon! For a live demo, please contact our sales team.
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Video Info */}
        <div className="bg-gray-800 px-6 py-4">
          <h4 className="text-white font-semibold text-lg">MyMedMember Platform Demo</h4>
          <p className="text-gray-400 text-sm">
            A complete walkthrough of features designed to grow your healthcare practice
          </p>
        </div>
      </div>
    </div>
  );
};

export default VideoModal;
